import { render, staticRenderFns } from "./chartjs-legend.vue?vue&type=template&id=9f2dfd62&scoped=true&"
import script from "./chartjs-legend.vue?vue&type=script&lang=js&"
export * from "./chartjs-legend.vue?vue&type=script&lang=js&"
import style0 from "./chartjs-legend.vue?vue&type=style&index=0&id=9f2dfd62&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2dfd62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f2dfd62')) {
      api.createRecord('9f2dfd62', component.options)
    } else {
      api.reload('9f2dfd62', component.options)
    }
    module.hot.accept("./chartjs-legend.vue?vue&type=template&id=9f2dfd62&scoped=true&", function () {
      api.rerender('9f2dfd62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/charts/chartjs-legend.vue"
export default component.exports